export function getColumnCheck(client_id, rate, config){
  var rateMap = {'USD':0, 'CAD':1, 'EUR':2, 'GBP':3} ;
  if (client_id && rate && config && config[client_id]){
    return !!+config[client_id].split(',')[rateMap[rate]];
  }else{
    return false;
  }
}
